"use strict";

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Confirmation = void 0;

var react_1 = __importDefault(require("react"));

var react_theme_components_1 = require("@suezenv/react-theme-components");

var task_ok_svg_1 = __importDefault(require("../../assets/img/task_ok.svg"));

var process_error_svg_1 = __importDefault(require("../../assets/img/process-error.svg"));

exports.Confirmation = function (_a) {
  var isMandat = _a.isMandat,
      loaderDlPdf = _a.loaderDlPdf,
      dlPdfMandat = _a.dlPdfMandat,
      changePaymentMethod = _a.changePaymentMethod,
      toDashoard = _a.toDashoard,
      _b = _a.modeOfPayment,
      modeOfPayment = _b === void 0 ? "paymentEtip" : _b,
      _c = _a.status,
      status = _c === void 0 ? "OK" : _c,
      messageError = _a.messageError;
  var textes = {
    paymentEtip: {
      titlePaymentChoice: "Revenir au choix de paiement",
      withMandat: {
        subtitle: "Vous allez recevoir un e-mail de confirmation avec les informations de la transaction."
      },
      noMandat: {
        subtitle: "Vous allez recevoir un e-mail de confirmation avec les informations de la transaction ainsi que le mandat SEPA que vous avez signé.",
        secondSubtitle: " Pour votre prochain paiement par e-TIP, votre mandat est enregistré, vous pourrez payer en un clic depuis votre compte en ligne."
      },
      status: {
        OK: {
          title: "Demande de prélèvement enregistrée avec succès"
        }
      }
    },
    paymentAuto: {
      titlePaymentChoice: "Revenir à l'espace facturation",
      withMandat: {
        subtitle: "Vous allez recevoir un e-mail de confirmation avec les informations de la transaction."
      },
      noMandat: {
        subtitle: "Vous allez recevoir un e-mail de confirmation avec les informations de la transaction ainsi que le mandat SPS que vous avez signé.",
        secondSubtitle: " Pour votre prochain paiement auto, votre mandat est enregistré, vous pourrez payer en un clic depuis votre compte en ligne."
      },
      status: {
        OK: {
          title: "Demande de prélèvement enregistrée avec succès"
        },
        KO: {
          title: "Demande de prélèvement echouée",
          subtitle: "Texte complémentaire .. Et prima post Osdroenam quam, ut dictum est, ab hac descriptione discrevimus, Commagena, nunc Euphratensis, clementer adsurgit, Hierapoli, vetere Nino et Samosata civitatibus amplis inlustris."
        },
        CANCEL: {
          title: "Demande de prélèvement annulée",
          subtitle: "Texte complémentaire .. Et prima post Osdroenam quam, ut dictum est, ab hac descriptione discrevimus, Commagena, nunc Euphratensis, clementer adsurgit, Hierapoli, vetere Nino et Samosata civitatibus amplis inlustris."
        }
      }
    }
  };
  return react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    className: "container pt-3 pb-4 pt-md-0 px-0 px-md-5"
  }, react_1.default.createElement("div", {
    className: "row"
  }, react_1.default.createElement("div", {
    className: "col-12 col-md-8"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    variant: "huge",
    className: "h1 mb-0 d-none d-md-block",
    weight: "bold"
  }, textes[modeOfPayment].status[status].title), react_1.default.createElement(react_theme_components_1.SzTypographie, {
    className: "mb-0 d-block d-md-none",
    weight: "bold"
  }, textes[modeOfPayment].status[status].title), react_1.default.createElement("div", {
    className: "row mt-4 mb-2 mb-md-5"
  }, status === "OK" ? react_1.default.createElement(react_1.default.Fragment, null, isMandat ? react_1.default.createElement(react_theme_components_1.SzTypographie, {
    className: "col-12 col-md-9",
    variant: "caption",
    weight: "medium",
    color: "disabled"
  }, textes[modeOfPayment].withMandat.subtitle) : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    className: "col-12 col-md-9",
    variant: "caption",
    weight: "medium",
    color: "disabled"
  }, textes[modeOfPayment].noMandat.subtitle), react_1.default.createElement(react_theme_components_1.SzTypographie, {
    className: "col-12 col-md-9 mt-2",
    variant: "caption",
    weight: "medium",
    color: "disabled"
  }, textes[modeOfPayment].noMandat.secondSubtitle))) : react_1.default.createElement(react_theme_components_1.SzTypographie, {
    className: "col-12 col-md-9",
    variant: "caption",
    weight: "medium",
    color: "disabled"
  }, textes[modeOfPayment].status[status].subtitle)), react_1.default.createElement("div", {
    className: "row d-block d-md-none"
  }, status === "OK" ? react_1.default.createElement("img", {
    src: task_ok_svg_1.default,
    alt: "tache ok",
    className: "col-12"
  }) : react_1.default.createElement("img", {
    src: process_error_svg_1.default,
    alt: "tache ko",
    className: "col-12"
  })), react_1.default.createElement("div", {
    className: "row text-center  text-md-left"
  }, status === "OK" ? react_1.default.createElement(react_1.default.Fragment, null, isMandat ? react_1.default.createElement("div", {
    className: "col-12 col-md-5 mb-4 mb-md-0"
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    variant: "tertiary",
    icon: "layout-dashboard",
    onClick: toDashoard
  }, "Aller au tableau de bord")) : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    className: "col-12 col-md-5 mb-4 mb-md-0"
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    icon: "common-file-text-download",
    className: "cy-btn-download-mandat",
    loader: loaderDlPdf,
    onClick: dlPdfMandat
  }, "T\xE9l\xE9charger le mandat")), react_1.default.createElement("div", {
    className: "col-12 col-md-5 mb-4 mb-md-0"
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    variant: "tertiary",
    icon: "layout-dashboard",
    onClick: toDashoard
  }, "Aller au tableau de bord")))) : react_1.default.createElement(react_1.default.Fragment, null, react_1.default.createElement("div", {
    className: "col-12 col-md-6 mb-4 mb-md-0"
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    icon: "synchronize-arrow-1",
    onClick: changePaymentMethod
  }, textes[modeOfPayment].titlePaymentChoice)), react_1.default.createElement("div", {
    className: "col-12 col-md-6 mb-4 mb-md-0"
  }, react_1.default.createElement(react_theme_components_1.SzButton, {
    variant: "tertiary",
    icon: "layout-dashboard",
    onClick: toDashoard
  }, "Aller au tableau de bord"))))), react_1.default.createElement("div", {
    className: "col-12 col-md-4 d-none d-md-block"
  }, status === "OK" ? react_1.default.createElement("img", {
    src: task_ok_svg_1.default,
    alt: "tache ok",
    className: " pt-4 pl-5"
  }) : react_1.default.createElement("img", {
    src: process_error_svg_1.default,
    alt: "tache ok",
    className: " pt-4 pl-5"
  })))), modeOfPayment === "paymentEtip" && react_1.default.createElement("div", {
    className: "confirmation-bloc position-relative"
  }, react_1.default.createElement("div", {
    className: "row no-gutters bg-white py-4 px-4 px-md-5 mb-3 mb-md-0"
  }, react_1.default.createElement(react_theme_components_1.SzTypographie, {
    weight: "regular",
    className: "col-md-7 ml-0 ml-md-4"
  }, "Simplifiez-vous la vie ! G\xE9rez en toute tranquillit\xE9 votre budget en optant pour le pr\xE9l\xE8vement automatique mensuel ou \xE0 la facture."), react_1.default.createElement(react_theme_components_1.SzButton, {
    variant: "secondary",
    className: "offset-md-1 col-md-3 mt-3 ml-auto mr-md-3",
    onClick: changePaymentMethod
  }, "Changer de mode de paiement"))), messageError && react_1.default.createElement("div", {
    className: "row",
    style: {
      marginLeft: "-4.6rem",
      marginRight: "-4.6rem",
      background: "var(--gray-0)",
      padding: "1rem 4.6rem"
    }
  }, react_1.default.createElement(react_theme_components_1.SzAlert, {
    variant: "danger",
    className: "cy-error-message col-12 mb-0 bg-transparent"
  }, messageError)));
};

exports.default = exports.Confirmation;